export const SHOULD_AUTHENTICATE = 'SHOULD_AUTHENTICATE_TOKEN';
export const PROVIDE_ACCESS_TOKEN = 'PROVIDE_ACCESS_TOKEN_TOKEN';
export const PROVIDE_REFRESH_TOKEN = 'PROVIDE_REFRESH_TOKEN_TOKEN';
export const REQUEST_AUTHENTICATOR = 'REQUEST_AUTHENTICATOR';
export const AUTHENTICATED_SESSION_STORAGE = 'AUTHENTICATED_SESSION_STORAGE';
export const SESSION_REFRESHER = 'SESSION_REFRESHER_TOKEN';
